import { createEnum } from "@redotech/zod/zod-enum";

export enum RedoListingStatus {
  ACTIVE = "active",
  DRAFT = "draft",
  ARCHIVED = "archived",
  INACTIVE = "inactive",
}
export const RedoListingStatusSchema = createEnum(RedoListingStatus);
